const getAttributeContent = (selector: string): string =>
    document.querySelector(selector)?.getAttribute('content') ?? '';

export const FABRIC_BASE_URL = getAttributeContent('meta[name="fabric-base-url"]').replace(
    /\/$/,
    '',
); // Trim trailing slash
export const AUTH_SERVER_BASE_URL = getAttributeContent('meta[name="auth-server-base-url"]');
export const PLATFORM_SERVER_BASE_URL = getAttributeContent(
    'meta[name="platform-server-base-url"]',
);
export const PENDO_API_KEY = '6f621fb5-a115-4088-7d59-9bad314c05dd';
